<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="icon/action/list_24px">
<g id="Vector">
<path d="M3 13H5V11H3V13Z" fill="black" fill-opacity="0.54"/>
<path d="M3 17H5V15H3V17Z" fill="black" fill-opacity="0.54"/>
<path d="M3 9H5V7H3V9Z" fill="black" fill-opacity="0.54"/>
<path d="M7 13H21V11H7V13Z" fill="black" fill-opacity="0.54"/>
<path d="M7 17H21V15H7V17Z" fill="black" fill-opacity="0.54"/>
<path d="M7 7V9H21V7H7Z" fill="black" fill-opacity="0.54"/>
</g>
</g>
</svg>
